"use strict";
function postalCodeValidator(length) {
    return function (control) {
        if (control.value) {
            if (length && control.value.length !== length) {
                return { 'length': true };
            }
            var pattern = /^\d{5}$/;
            if (!pattern.test(control.value)) {
                return { 'invalid': true };
            }
        }
        return null;
    };
}
exports.postalCodeValidator = postalCodeValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/postal-code.validator.js